// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__B6MGu","disabled":"TextArea_disabled__Wyar5"};